import { ReactComponent as ContabilityIcon } from '../../../../../assets/icons/Navegation/contabilidad.svg';
import { ReactComponent as SubmenuIcon } from '../../../../../assets/icons/Navegation/submenu-flecha.svg';
import { icons, triangle, headerTitleStyle } from '../Styles/StylesIcons';
import GenericCollapse from './GenericCollapse';
import GenericNavListItem from './GenericNavListItem';
import GenericListItemButton from './MenuItemWithSubmenu';
import Popover from '@mui/material/Popover';
import Divider from '@mui/material/Divider';

const TriangleIcon = (props) => <SubmenuIcon style={triangle} {...props} />;

const AccountingMenu = ({
  userPermissions,
  openMenuAccounting,
  handleClickMenuAccounting,
  activeStyle,
  drawerOpen,
  header,
  handlePopoverOpen,
  handlePopoverClose,
  openPopover,
  anchorEl,
}) => {
  const submenuContent = (
    <>
      {userPermissions?.includes('ACCOUNTING') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='ACCOUNTING'
          to='/listado/ipb'
          title='Facturas IPB'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('ACCOUNTING') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='ACCOUNTING'
          to='/editar/datos-fiscales'
          title='Datos Fiscales IPB'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
    </>
  );

  return (
    <>
      {userPermissions?.includes('ACCOUNTING') && (
        <>
          <Divider style={{ margin: '0 0 4px 0' }} />
          {drawerOpen && (
            <>
              {header?.accounting?.kind === 'header' && (
                <div style={headerTitleStyle}>{header.accounting.title}</div>
              )}
            </>
          )}
          <GenericListItemButton
            onClick={drawerOpen ? handleClickMenuAccounting : handlePopoverOpen}
            className={'layout-menu-submenu'}
            title='IPB'
            IconComponent={(props) => <ContabilityIcon style={icons} {...props} />}
            openMenu={openMenuAccounting}
          />
          {drawerOpen && (
            <GenericCollapse
              className={'layout-menu-submenu-options'}
              openMenu={openMenuAccounting}
              userPermissions={userPermissions}
            >
              {submenuContent}
            </GenericCollapse>
          )}
          {!drawerOpen && (
            <Popover
              open={openPopover}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              onBlur={handlePopoverClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                style: { minWidth: 220 },
                onMouseLeave: handlePopoverClose,
              }}
            >
              <div style={{ padding: 8 }}>{submenuContent}</div>
            </Popover>
          )}
        </>
      )}
    </>
  );
};

export default AccountingMenu;
